import styled from 'styled-components';

export const StudioDisplayName = styled.span`
  display: inline-block;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  margin-left: 8px;
`;

export default StudioDisplayName;
